import { Box, Grid, TextField, Typography, Checkbox, FormControlLabel, Stack } from '@mui/material';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import { Modal } from 'react-bootstrap';
import cross from '../../../../assets/images/ic-cancel.svg';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import {
    CreateListWithProcess,
    CreateOnBoarding,
    CreateOnBoardingProcess,
    GetAllEmployee,
    GetAllOnBoardingProcess,
    GetOnBoardingById,
    UpdateOnBoarding,
} from '../../../../reduxToolkit/EmployeeOnBoarding/EmployeeOnBoardingApi';
import {
    ResetOnboardingById,
    ResetOnboardingProcess,
} from '../../../../reduxToolkit/EmployeeOnBoarding/EmployeeOnBoardingSlice';
import { toast } from 'react-toastify';

import uuid from 'react-uuid';
import ReturnArrow from '../../../../components/buttons/ReturnArrow';
import { t } from 'i18next';
import AutoCompleteSearch from '../../../../components/AutoCompleteSearch';
import DeleteModal from '../../../Modals/DeleteModal';
import { DeleteItemsApi } from '../../../../reduxToolkit/Commons/CommonsApi';

import { getAllZones } from '../../../../Apis/Zones';
import {filterByLabelEmailPhone} from "../../../../Apis/functions";
import ButtonAction from '../../../../components/buttons/ButtonAction';
import { TrashOutlineIcon } from '../../../../components/buttons/IconButtons';

/*
Author : Arman Ali
Module: onbarding ue
github: https://github.com/Arman-Arzoo
*/

const OnBoardingUE = () => {
    let max = 500;

    const params = useParams();
    const dispatch = useDispatch();

    const [show, setShow] = useState(false);
    const [message, setMessage] = useState(null);
    const [manager, setManager] = useState(null);
    const [workStation, setWorkStation] = useState(null);
    const [workStationName] = useState('');
    const [managerName] = useState('');
    const [createStep, setCreateStep] = useState([]);
    const [, setIsAllCheckedProcess] = useState(false);
    const [selectProcessForDelete, setSelectProcessForDelete] = useState([]);
    const [, setIsAllCheckedCustomProcess] = useState(false);
    const [selectCustomProcessForDelete, setSelectCustomProcessForDelete] = useState([]);
    const [processShow, setProcessShow] = useState(false);
    const [processCustomShow, setProcessCustomShow] = useState(false);

    //use Selector hook to get state for redux store
    const { getallEmployee } = useSelector((state) => state.employeeOnBoardingSlice);
    const { getOnBoardingById } = useSelector((state) => state.employeeOnBoardingSlice);
    const { createOnBoardingProcess } = useSelector((state) => state.employeeOnBoardingSlice);
    const { deleteOnboardingProcess } = useSelector((state) => state.employeeOnBoardingSlice);
    const { updateOnBoarding } = useSelector((state) => state.employeeOnBoardingSlice);
    const { createOnBoarding } = useSelector((state) => state.employeeOnBoardingSlice);
    const { getAllOnBoardingProcess } = useSelector((state) => state.employeeOnBoardingSlice);

    const { deleteItemsApi } = useSelector((state) => state.CommonsSlice);
    const lCode = Cookies.get('i18next') || 'en';
    const [allZonesInList, setAllZonesInList] = useState();
    const navigate = useNavigate();

    const [workStationError, setWorkStationError] = useState('');
    const [managerError, setManagerError] = useState('');
    const [welcomeMessageError, setWelcomeMessageError] = useState('');

    const deleteProcess = (deleteItem) => {
        const tableName = 'onboarding_process';
        const body = deleteItem;
        dispatch(DeleteItemsApi({ tableName, body }));
        setSelectProcessForDelete([]);
        setIsAllCheckedProcess(false);
    };
    const deleteCustomProcess = () => {
        const updatedItems = createStep.filter((item) => !selectCustomProcessForDelete.includes(item.id));
        setCreateStep(updatedItems);
        setSelectCustomProcessForDelete([]);
    };
    // this function control select all id or unSelect all
    const handelDeleteAllProcess = (e) => {
        setIsAllCheckedProcess(e.target.checked);
        if (e.target.checked) {
            const selectAllIds = getAllOnBoardingProcess?.map((item) => {
                return item?.id;
            });
            setSelectProcessForDelete(selectAllIds);
        } else {
            setSelectProcessForDelete([]);
        }
    };
    // this function handle only specific id base on selection
    const handleCheckboxChangeProcess = (e) => {
        if (e.target.checked) {
            setSelectProcessForDelete([...selectProcessForDelete, e.target.id]);
        } else {
            setSelectProcessForDelete(selectProcessForDelete.filter((removeid) => removeid !== e.target.id));
        }
    };
    const handelDeleteAllCustomProcess = (e) => {
        setIsAllCheckedCustomProcess(e.target.checked);
        if (e.target.checked) {
            const selectAllIds = createStep?.map((item) => {
                return item?.id;
            });
            setSelectCustomProcessForDelete(selectAllIds);
        } else {
            setSelectCustomProcessForDelete([]);
        }
    };
    const handleCheckboxChangeCustomProcess = (e) => {
        if (e.target.checked) {
            setSelectCustomProcessForDelete([...selectCustomProcessForDelete, e.target.id]);
        } else {
            setSelectCustomProcessForDelete(
                selectCustomProcessForDelete.filter((removeid) => removeid !== e.target.id),
            );
        }
    };
    // object for create and update onboarding
    const createOnboardingActionData = {
        introduction: message,
        managerId: manager?.id,
        managerName: managerName,
        processNo: getOnBoardingById?.name,
        roleId: sessionStorage.getItem('onBoardingRoleId'),
        roleName: sessionStorage.getItem('onBoardingRoleName'),
        zoneId: workStation?.id,
        zoneName: workStationName,
    };
    const updateOnboardingActionData = {
        id: params?.id,
        introduction: message,
        managerId: manager?.id,
        zoneId: workStation?.id,
    };
    // handel the logic for object transformation for all user
    const userDataTransform = (tras) => {
        const newData = tras?.map((item) => {
            return {
                label:
                    (item?.name || '') +
                    ' ' +
                    (item?.firstLastName || '') +
                    (item?.secondLastName ? ' ' + item.secondLastName : ''),
                id: item?.userId,
            };
        });

        return newData;
    };
    // handel the logic for object transformation for all user
    const userDataTransformWorkstation = (tras) => {
        const newData = tras?.map((item) => {
            return {
                label: item?.name,
                id: item?.id,
            };
        });

        return newData;
    };

    // useEffect to check update data
    useEffect(() => {
        setManager({ id: getOnBoardingById?.user?.id || '', label: getOnBoardingById?.user?.name || '' });
        setMessage(getOnBoardingById?.introduction || '');
        setWorkStation({ id: getOnBoardingById?.zone?.id || '', label: getOnBoardingById?.zone?.name || '' });
    }, [getOnBoardingById?.id, params?.id]);
    // useEffect for get all on boarding  and process by it ID
    useEffect(() => {
        if (params?.id != 'null') {
            dispatch(GetOnBoardingById(params?.id));
            dispatch(GetAllOnBoardingProcess(params?.id));
        } else {
            dispatch(ResetOnboardingById());
            dispatch(ResetOnboardingProcess());
        }
    }, [deleteOnboardingProcess, createOnBoardingProcess, updateOnBoarding, createOnBoarding, deleteItemsApi]);

    useEffect(() => {
        dispatch(GetAllEmployee());
    }, []);

    useEffect(() => {
        const fetchGetAllZones = async () => {
            const response = await getAllZones();
            if (response.status === 200) {
                setAllZonesInList(response.data.data);
            } else {
                console.error('Error al obtener las zonas de la base de datos: ', response);
            }
        };
        fetchGetAllZones();
    }, []);

    //LOGICA DEL BOTÓN DE GUARDAR / ACTUALIZAR INFORMACIÓN
    const handleInformationToUpload = () => {
        const data = params?.id != 'null' ? updateOnboardingActionData : createOnboardingActionData;
        const checkId = params?.id;
        const createProcessIds = createStep;
        createOnboardingAction(checkId, data, createProcessIds);
    };
    const createOnboardingAction = (checkId, data, createProcessIds) => {
        const missingWorkStation = !workStation?.id;
        const missingManager = !manager?.id;
        const missingWelcomeMessage = !message?.trim();

        setWorkStationError(missingWorkStation ? 'This Field Is Required!' : '');
        setManagerError(missingManager ? 'This Field Is Required!' : '');
        setWelcomeMessageError(missingWelcomeMessage ? 'This Field Is Required!' : '');

        // Work station, manager and welcome message are required to create or update the onboarding
        if (missingWorkStation || missingManager || missingWelcomeMessage) {
            toast.warn(t('please_fill_all_fields'));
            return;
        }

        if (checkId === 'null') {
            dispatch(CreateOnBoarding(data)).then((res) => {
                dispatch(
                    CreateListWithProcess(
                        createProcessIds?.map((item) => {
                            return {
                                process: item?.process,
                                onboarding: {
                                    id: res?.payload?.data?.data?.id,
                                },
                            };
                        }),
                    ),
                ).then(() => {
                    navigate('/dashboard/employee/company/onboarding');
                });
            });
        } else {
            dispatch(UpdateOnBoarding(data)).then(() => {
                navigate('/dashboard/employee/company/onboarding');
            });
        }
    };
    return (
        <>
            <Box className='on_boarding'>
                <div className='head'>
                    <div className='headLeft'>
                        <ReturnArrow link={'/dashboard/employee/company/onboarding'} />
                        <h2>{params?.id != 'null' ? t('update')?.toUpperCase() : t('create')?.toUpperCase()}</h2>
                    </div>

                    <div className='container-top-right-btns'>
                        {params?.id !== 'null' ? (
                            <ButtonAction
                                id='btn_ob_step_delete'
                                name='delete'
                                className='btn-icon-delete'
                                disabled={selectProcessForDelete?.length === 0}
                                Icon={TrashOutlineIcon}
                                onClick={() => {
                                    setProcessShow(true);
                                }}
                            />
                        ) : (
                            <ButtonAction
                                id='btn_ob_custom_step_delete'
                                name='delete'
                                className='btn-icon-delete'
                                disabled={selectCustomProcessForDelete?.length === 0}
                                Icon={TrashOutlineIcon}
                                onClick={() => {
                                    setProcessCustomShow(true);
                                }}
                            />
                        )}
                    </div>
                </div>

                <Box className='on_boarding_create_edit'>
                    <Box className='on_boarding_detail'>
                        <h4>{t('details')}</h4>
                        <h5>{t('privilege')}</h5>
                        <p>{getOnBoardingById?.role?.name || sessionStorage.getItem('onBoardingRoleName')}</p>
                        <Grid container gap='1.5rem'>
                            <Box className='w-100'>
                                <AutoCompleteSearch
                                    required
                                    error={!workStation?.id && workStationError.length > 0}
                                    data={userDataTransformWorkstation(allZonesInList)}
                                    value={workStation}
                                    handleFn={() => {}}
                                    label={t('work_station')}
                                    setValue={setWorkStation}
                                    defaultState={getOnBoardingById?.zone?.id || null}
                                    reset={false}
                                    filterOptions={filterByLabelEmailPhone}
                                />
                            </Box>
                            <Box className='w-100'>
                                <AutoCompleteSearch
                                    error={!manager?.id && managerError.length > 0}
                                    data={userDataTransform(getallEmployee)}
                                    value={manager}
                                    label={t('manager')}
                                    setValue={setManager}
                                    handleFn={() => {}}
                                    defaultState={getOnBoardingById?.user?.id || ''}
                                    reset={false}
                                    filterOptions={filterByLabelEmailPhone}
                                />
                            </Box>

                            <Grid className='w-100-r'>
                                <TextField
                                    size='small'
                                    fullWidth
                                    required
                                    error={!message?.trim() && welcomeMessageError.length > 0}
                                    type='text'
                                    label={t('welcome_message')?.toUpperCase()}
                                    id='welcome-message'
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                    multiline
                                    rows={5}
                                    maxRows={10}
                                    InputLabelProps={{
                                        className: 'welcome-message-label',
                                    }}
                                    inputProps={{
                                        maxLength: 500,
                                        minLength: 124,
                                    }}
                                    sx={{
                                        textAlign: lCode === 'ar' ? 'right' : 'left',
                                    }}
                                    className={lCode === 'ar' ? 'welcome-message-input-ar' : 'welcome-message-input'}
                                />

                                <Typography className='bottom_number'>
                                    {message?.length}/{max} {t('max')?.toUpperCase()}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box className='on_boarding_todo'>
                        <Stack direction='row' alignItems='center' justifyContent='space-between' paddingTop='1rem'>
                            {params?.id != 'null' && getAllOnBoardingProcess?.length > 0 && (
                                <>
                                    <FormControlLabel
                                        className='margin-left-small'
                                        control={
                                            <Checkbox
                                                label='Label'
                                                checked={selectProcessForDelete?.length > 0}
                                                onChange={handelDeleteAllProcess}
                                                indeterminate={
                                                    selectProcessForDelete?.length > 0 &&
                                                    getAllOnBoardingProcess?.length !== selectProcessForDelete?.length
                                                }
                                                size='small'
                                            />
                                        }
                                        label={t('de_/_select_all')}
                                    />
                                    <Stack
                                        direction='column'
                                        alignItems='center'
                                        justifyContent='space-between'
                                        paddingBottom='3rem'
                                    >
                                        <h4>{t('to_do')?.toUpperCase()}</h4>
                                        <h6>
                                            {t('things_to_do')?.toUpperCase()}: {getAllOnBoardingProcess?.length}
                                        </h6>
                                    </Stack>
                                </>
                            )}
                            {params?.id === 'null' && createStep?.length > 0 && (
                                <>
                                    <FormControlLabel
                                        className='margin-left-small'
                                        control={
                                            <Checkbox
                                                label='Label'
                                                checked={selectCustomProcessForDelete?.length > 0}
                                                onChange={handelDeleteAllCustomProcess}
                                                indeterminate={
                                                    selectCustomProcessForDelete?.length > 0 &&
                                                    selectCustomProcessForDelete?.length !== createStep?.length
                                                }
                                                size='small'
                                            />
                                        }
                                        label={t('de_/_select_all')}
                                    />
                                    <h6>
                                        {t('things_to_do')?.toUpperCase()}: {createStep?.length}
                                    </h6>
                                </>
                            )}
                        </Stack>

                        <Box className='on_boarding_todo_list_container'>
                            {params?.id != 'null' &&
                                (getAllOnBoardingProcess?.length > 0 ? (
                                    getAllOnBoardingProcess?.map((item) => (
                                        <Box className='on_boarding_todo_lists'>
                                            <Checkbox
                                                checked={selectProcessForDelete?.includes(item?.id)}
                                                id={item?.id}
                                                onChange={handleCheckboxChangeProcess}
                                                size='small'
                                            />
                                            <p>{item?.process}</p>
                                        </Box>
                                    ))
                                ) : (
                                    <></>
                                ))}
                            {params?.id === 'null' &&
                                (createStep?.length > 0 ? (
                                    createStep?.map((item) => (
                                        <Box className='on_boarding_todo_lists'>
                                            <Checkbox
                                                checked={selectCustomProcessForDelete?.includes(item?.id)}
                                                id={item?.id}
                                                onChange={handleCheckboxChangeCustomProcess}
                                                size='small'
                                            />
                                            <p>{item?.process}</p>
                                        </Box>
                                    ))
                                ) : (
                                    <></>
                                ))}
                            <button
                                onClick={() => {
                                    setShow(true);
                                }}
                                className='add_new_step_btn'
                            >
                                {t('add_new_step')?.toUpperCase()}{' '}
                                <i className='fa fa-plus plus plus_icon' aria-hidden='true'></i>
                            </button>
                        </Box>

                        <AddStepModal
                            show={show}
                            onHide={() => setShow(false)}
                            onboardingId={params?.id}
                            setCreateStep={setCreateStep}
                        />
                        <br />
                        <Box className='center-box-btn'>
                            <button
                                className='create_btn btn-100-c'
                                onClick={() => {
                                    handleInformationToUpload();
                                }}
                            >
                                {params?.id != 'null' ? t('update')?.toUpperCase() : t('create')?.toUpperCase()}
                            </button>
                        </Box>
                    </Box>
                </Box>
            </Box>

            <DeleteModal
                show={processShow}
                onHide={() => setProcessShow(false)}
                onClickFn={() => deleteProcess(selectProcessForDelete)}
                data={selectProcessForDelete}
                title_modal={'remove'}
                element_modal={'step'}
                isReset={setSelectProcessForDelete}
                isAllReset={setIsAllCheckedProcess}
            />

            <DeleteModal
                show={processCustomShow}
                onHide={() => setProcessCustomShow(false)}
                onClickFn={() => deleteCustomProcess(selectCustomProcessForDelete)}
                data={selectCustomProcessForDelete}
                title_modal={'remove'}
                element_modal={'step'}
                isReset={setSelectCustomProcessForDelete}
                isAllReset={setIsAllCheckedCustomProcess}
            />
        </>
    );
};

export const AddStepModal = (props) => {
    const dispatch = useDispatch();
    const [message, setMessage] = useState('');
    let max = 500;

    const addStepAction = () => {
        const data = {
            process: message,
            onboarding: {
                id: props?.onboardingId,
            },
        };
        if (message) {
            if (props.onboardingId != 'null') {
                dispatch(CreateOnBoardingProcess(data)).then(() => {
                    toast.success(t('has_been_created_successfully'));

                    props.onHide();
                    setMessage('');
                });
                props?.onHide();
            } else {
                props?.setCreateStep((prevState) => [...prevState, { id: uuid(), process: message }]);
                setMessage('');
                props?.onHide();
            }
        } else {
            toast.warn(t('please_enter_an_instruction').toUpperCase());
        }
    };
    return (
        <Modal className='filter_device_model' {...props} aria-labelledby='contained-modal-title-vcenter' centered>
            <Modal.Header className='fiter_event_model_head'>
                <Modal.Title className='asm-title'>{t('add_step')}</Modal.Title>
                <img src={cross} className='asm-img' onClick={() => props.onHide()} />
            </Modal.Header>
            <Modal.Body>
                <p className='title'>{t('fill_on_the_input_the_step_to_follow_it')}</p>
                <Grid className='relative-full-width'>
                    <TextField
                        size='small'
                        fullWidth
                        type='text'
                        label={t('instruction')}
                        id='message'
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        multiline
                        rows={5}
                        maxRows={10}
                        InputLabelProps={{
                            className: 'asm-clase-label',
                        }}
                        inputProps={{
                            maxLength: 500,
                            className: 'instructions',
                        }}
                        className='on-text-field-spacing'
                    />
                    <Typography className='bottom_number_modal number'>
                        {message.length}/{max} {t('max')?.toUpperCase()}
                    </Typography>
                </Grid>
                <div className='btn-div on-btn-div'>
                    <button
                        className='button-sec btn-cancel font-color-error-600'
                        onClick={() => {
                            props.onHide();
                            setMessage('');
                        }}
                    >
                        {t('cancel')?.toUpperCase()}
                    </button>
                    <button
                        className='button-sec btn-confirm'
                        onClick={() => {
                            addStepAction();
                        }}
                    >
                        {t('confirm')?.toUpperCase()}
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default OnBoardingUE;
